/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
/**
 * 
 * @export
 * @interface CreateOrUpdateBeamAnalysisCorrectionsDto
 */
export interface CreateOrUpdateBeamAnalysisCorrectionsDto {
    /**
     * 
     * @type {number}
     * @memberof CreateOrUpdateBeamAnalysisCorrectionsDto
     */
    airTemperature: number;
    /**
     * 
     * @type {boolean}
     * @memberof CreateOrUpdateBeamAnalysisCorrectionsDto
     */
    adjustAirTemperature?: boolean;
    /**
     * 
     * @type {number}
     * @memberof CreateOrUpdateBeamAnalysisCorrectionsDto
     */
    airPressure: number;
    /**
     * 
     * @type {boolean}
     * @memberof CreateOrUpdateBeamAnalysisCorrectionsDto
     */
    adjustAirPressure?: boolean;
    /**
     * 
     * @type {number}
     * @memberof CreateOrUpdateBeamAnalysisCorrectionsDto
     */
    referenceTemperature: number;
    /**
     * 
     * @type {boolean}
     * @memberof CreateOrUpdateBeamAnalysisCorrectionsDto
     */
    adjustReferenceTemperature?: boolean;
    /**
     * 
     * @type {number}
     * @memberof CreateOrUpdateBeamAnalysisCorrectionsDto
     */
    referencePressure: number;
    /**
     * 
     * @type {number}
     * @memberof CreateOrUpdateBeamAnalysisCorrectionsDto
     */
    correctionFactor: number;
    /**
     * 
     * @type {boolean}
     * @memberof CreateOrUpdateBeamAnalysisCorrectionsDto
     */
    adjustCorrectionFactor?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateOrUpdateBeamAnalysisCorrectionsDto
     */
    $type?: CreateOrUpdateBeamAnalysisCorrectionsDtoTypeEnum;
}


/**
 * @export
 */
export const CreateOrUpdateBeamAnalysisCorrectionsDtoTypeEnum = {
    PtwPtw100BeamAnalysisApplicationTaskItemComponentDtoCreateOrUpdateBeamAnalysisCorrectionsDtoPtwPtw100BeamAnalysisApplication: 'Ptw.Ptw100.BeamAnalysis.Application.TaskItemComponent.Dto.CreateOrUpdateBeamAnalysisCorrectionsDto, Ptw.Ptw100.BeamAnalysis.Application'
} as const;
export type CreateOrUpdateBeamAnalysisCorrectionsDtoTypeEnum = typeof CreateOrUpdateBeamAnalysisCorrectionsDtoTypeEnum[keyof typeof CreateOrUpdateBeamAnalysisCorrectionsDtoTypeEnum];



/**
 * Check if a given object implements the CreateOrUpdateBeamAnalysisCorrectionsDto interface.
 */
export function instanceOfCreateOrUpdateBeamAnalysisCorrectionsDto(value?: unknown): value is CreateOrUpdateBeamAnalysisCorrectionsDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(CreateOrUpdateBeamAnalysisCorrectionsDtoTypeEnum)[0];
}

export function CreateOrUpdateBeamAnalysisCorrectionsDtoFromJSON(json: any): CreateOrUpdateBeamAnalysisCorrectionsDto {
    return CreateOrUpdateBeamAnalysisCorrectionsDtoFromJSONTyped(json, false);
}

export function CreateOrUpdateBeamAnalysisCorrectionsDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateOrUpdateBeamAnalysisCorrectionsDto {
    if (json == null) {
        return json;
    }
    return {
        
        'airTemperature': json['airTemperature'],
        'adjustAirTemperature': json['adjustAirTemperature'] == null ? undefined : json['adjustAirTemperature'],
        'airPressure': json['airPressure'],
        'adjustAirPressure': json['adjustAirPressure'] == null ? undefined : json['adjustAirPressure'],
        'referenceTemperature': json['referenceTemperature'],
        'adjustReferenceTemperature': json['adjustReferenceTemperature'] == null ? undefined : json['adjustReferenceTemperature'],
        'referencePressure': json['referencePressure'],
        'correctionFactor': json['correctionFactor'],
        'adjustCorrectionFactor': json['adjustCorrectionFactor'] == null ? undefined : json['adjustCorrectionFactor'],
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function CreateOrUpdateBeamAnalysisCorrectionsDtoToJSON(value?: CreateOrUpdateBeamAnalysisCorrectionsDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'airTemperature': value['airTemperature'],
        'adjustAirTemperature': value['adjustAirTemperature'],
        'airPressure': value['airPressure'],
        'adjustAirPressure': value['adjustAirPressure'],
        'referenceTemperature': value['referenceTemperature'],
        'adjustReferenceTemperature': value['adjustReferenceTemperature'],
        'referencePressure': value['referencePressure'],
        'correctionFactor': value['correctionFactor'],
        'adjustCorrectionFactor': value['adjustCorrectionFactor'],
        '$type': value['$type'],
    });
}

